import React from 'react';
import {FormattedMessage} from 'react-intl';
import Spinner from '../../components/Spinner';
import { Auth } from 'aws-amplify';
import { currentLang } from '../../components/components/utils'
import PopupLink from '../../templates/PopupLink';
function InitiateAuth({navigation}) {

	Auth.federatedSignIn({ customProvider: 'bag' });

	return (
		<>
		  <Spinner show={true} />
		</>
	);
}

InitiateAuth.path = "initiateAuth";
InitiateAuth.navigationOptions = {
	pageTitle: ""
	, breadcrumb: [
		<PopupLink url={window.env["canada-url"][currentLang()]}><FormattedMessage id="breadcrumb.Canada.text" /></PopupLink>
		, <PopupLink url={window.env["cbsa-breadcrumbs-url"][currentLang()]}><FormattedMessage id="breadcrumb.CBSA.text" /></PopupLink>
		, <PopupLink url={window.env["cbsa-sima-breadcrumbs-url"][currentLang()]}><FormattedMessage id="breadcrumb.ACE.text" /></PopupLink>
	]
	, breadcrumbTitle: ""
};

export default InitiateAuth;